import { Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import ButtonComponent from "../shared/button/button.component";
import QRCode from "qrcode.react";
import { appLabels, appNote, buttonLabels, ToasterTexts, ViewTextLabels } from "../shared/constants";
import { EmailService } from "../../services/email.service";
import { useLocation } from "react-router-dom";
import { UtilityService } from "../../services/UtilityService";
import { IEstimateInvoiceModel, ILineItem } from "../../models/payment.model";
import FormTextField from "../shared/textfield-form";
import RegistraionLoaderAminationData from "../shared/loaders/payment-hostage-loader.json";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import { BackToPhoneNumberIcon, CancelIcon, DetailsIcon, PaymentCopyLinkIcon, PaymentLinkIcon, SendEmailIconSec, SuccessIcon } from "../../icon";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../routes/route.path";
import { ToasterType } from "../shared/toaster/toaster.model";
import setToast from "../../helpers/toaster.helper";
import { OrganizationDetails } from "../../models/organization.model";


interface IProps {
    PaymentLink: string;
    IsMobileDevice?: boolean;
    LoadingDetails: boolean;
    stepdata: any;
    ChargebeeInvoice: IEstimateInvoiceModel;
    OrgDetails: OrganizationDetails
}

const PaymentHostpageDetails = (props: IProps) => {
    const { state } = useLocation() as any;
    const navigate = useNavigate();
    const [copyLinkLabel, setCopyLinkLabel] = useState<boolean>(false);
    const [showEmail, showSendEmail] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({
        Name: props.OrgDetails?.Name || "",
        Email: props.OrgDetails?.Email || "",
    });

    const TextMessage = (text: string) => {
        return text?.slice(0, 50) + (text?.length > 50 ? "..." : "");
    }

    const HandleCopyLink = () => {
        setCopyLinkLabel(true)
    }

    const handleSendEmail = () => {
        let data = {
            Name: props.OrgDetails.Name || "",
            Email: props.OrgDetails.Email || "",
        }
        setFormData(data)
        showSendEmail(!showEmail);
    }

    const formatNumber = number => {
        const [integerPart, decimalPart] = String(number).split('.');
        const paddedDecimalPart = decimalPart ? decimalPart.padEnd(2, '0') : '00';
        return `${integerPart || '0'}.${paddedDecimalPart}`;
    };

    const sendEmail = (e?: any) => {
        e?.preventDefault();
        if (showLoader) { return }
        if (!state) {
            return;
        }
        setShowLoader(true);
        if (!showLoader) {
            EmailService.sendPaymentDueNotification(
                [{ Email: formData.Email, CustomerName: formData.Name }], {
                Amount: formatNumber(`${props.ChargebeeInvoice.DueAmount}`),
                PaymentLink: props.PaymentLink,
                PhoneNumber: props.OrgDetails.Name,
                PlanName: props.stepdata?.Plan?.Name,
                RenewalAmount: formatNumber(state?.IsAddonRecharge ? "0" : `${props.stepdata?.Tenure === "A" ? (props.stepdata?.Plan?.YPrice) * 12 : (props.stepdata?.Plan?.Price)}`),

                RenewalDate: state?.IsAddonRecharge ? "--" : props.stepdata?.Tenure === "A" ? UtilityService.dateFormat(new Date(props.ChargebeeInvoice?.RenewalDateTime).toISOString()) : UtilityService.dateFormat(new Date(new Date().setDate(32)).toISOString())
            }).then(x => {
                showSendEmail(false);
                setShowLoader(false);
                setToast("Email has been sent successfully", ToasterType.SUCCESS)
            })
                .catch(x => {
                    setShowLoader(false);
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
                })
        }
    }

    useEffect(() => {
        let data = {
            Name: props.OrgDetails?.Name || "",
            Email: props.OrgDetails?.Email || "",
        }
        setFormData(data)
    }, [])


    return <>
        <Grid container spacing={3} className={`${props.IsMobileDevice && 'p-1'} h-p-100 w-p-95 mx-auto`}>
            {props.LoadingDetails ? <Grid item xs={12} className={"d-flex justify-center my-auto"}>
                <AnimateLoader LoaderAnimation={RegistraionLoaderAminationData} className={`${props.IsMobileDevice ? 'w-9 h-9 pt-6 ' : 'w-15 h-15 '}`} />
            </Grid> :
                <Grid container direction={"row"} spacing={3} className="h-p-90 o-y-scroll">
                    <Grid item xs={12} md={6} lg={6} className={`px-2 ${props.IsMobileDevice ? '' : ' change-password-vertical-line'} `} >
                        <div className={`h2-semibold color-registration-title pt-4 pb-2`}>{appNote.PAYMENT_LINK}</div>
                        <TextField
                            className={"bg-color-payment-text-field w-fill br-2"}
                            variant="outlined"
                            type={"text"}
                            value={TextMessage(props.PaymentLink)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position='start'>
                                        <PaymentLinkIcon />
                                    </InputAdornment>),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton aria-label="toggle password visibility"
                                            onClick={() => { navigator.clipboard.writeText(props.PaymentLink); HandleCopyLink() }}
                                        >{copyLinkLabel ?
                                            <SuccessIcon className={"w-2"} /> :
                                            <PaymentCopyLinkIcon />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                classes: { input: 'h4-regular color-text-field-font', notchedOutline: 'b-none' }
                            }}
                        />
                        <div className={"py-1"}><small className={`h5-regular color-add-on-text`}>{appNote.COPY_LINK_FOR_CUSTOMER}</small></div>
                        <div className={"justify-center t-align-center w-p-100 mt-2 "}>
                            <QRCode
                                value={props.PaymentLink}
                                size={115}
                                includeMargin={true}
                                fgColor={"#013243"}
                            />
                        </div>
                        <div className={`d-flex mt-1 justify-center c-pointer align-center`} onClick={handleSendEmail}><SendEmailIconSec /><p className={`ml-1 h3-regular color-primary-link`}>{ViewTextLabels.SEND_EMAIL}</p></div>
                        <div className={"mx-auto mt-5"}>
                            <ButtonComponent ButtonLabel={buttonLabels.GO_TO_ORGANIZATIONS} Variant={'secondary-btn'} OnClick={() => navigate(AppRoutes.NEW_ORGANIZATION)} Icon={BackToPhoneNumberIcon} ClassName="w-fill justify-center" />
                            <p className="h6-regular">{appNote.CONTACT_FALKON_SMS}<a href={`mailto:${appLabels.FALKON_EMAIL}`} className="color-vigenary-light c-pointer" >{appLabels.FALKON_EMAIL}</a>
                                &nbsp;or &nbsp;
                                {ViewTextLabels.CALL_AT}&nbsp; <button color="primary" className="color-vigenary-light c-pointer" >{appLabels.FALKON_NUMBER}</button>
                            </p>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={6} className={`${props.IsMobileDevice ? '' : ''} px-2 mx-auto`}>
                        <div className={"h3-bold color-primary-accent px-2 pt-4"}>{appNote.ORDER_SUMMARY}</div>
                        <div className='d-flex flex-direction justify-between py-1 p-2'>
                            <div className='d-flex pb-1 justify-between bb-primary-divider-4'>
                                <div className='h5-semibold color-primary-accent'>{ViewTextLabels.DESCRIPTION}</div>
                                <div className={`h5-semibold color-primary-accent `}>{ViewTextLabels.PRICE}</div>
                            </div>
                            {
                                !props.LoadingDetails &&
                                props.ChargebeeInvoice?.LineItems.map((item: ILineItem) =>
                                    <>
                                        <div className='d-flex justify-between mt-1'>
                                            <Grid item xs={8}>
                                                <div className='h5-regular color-secondary-accent'>{props.LoadingDetails ? "--" : item.Description}</div>
                                            </Grid>
                                            <Grid item xs={4} className={""}>
                                                <div className={`h5-semibold color-add-on-text t-align-right`}>{`$ ${props.LoadingDetails ? "--" : Number(((item.Subtotal || 0) / 100)).toFixed(2)}`}</div>
                                            </Grid>
                                        </div>
                                    </>)
                            }
                            <div className='d-flex justify-between  pb-1 bb-primary-divider-4'></div>
                            <div className="d-flex pt-1">
                                <div className='h5-regular  color-secondary-accent ml-auto my-auto'>Sub Total:</div>
                                <div className='h5-semibold color-add-on-text ml-auto'>{props.LoadingDetails ? "--" : `$ ${(props.ChargebeeInvoice.Subtotal || 0)}`}</div>

                            </div>
                            <div className='d-flex justify-between mt-1 pb-1 bb-primary-divider-4'>
                                <div className='h5-regular  color-secondary-accent d-flex'>
                                    Tax ({props.ChargebeeInvoice.TaxRatio})  {!props.LoadingDetails && (props.ChargebeeInvoice.TaxDescription) && <Tooltip className="ml-1 my-auto" placement={"top"} title={props.ChargebeeInvoice.TaxDescription} arrow>
                                        <DetailsIcon />
                                    </Tooltip>}
                                </div>
                                <div className='h5-semibold color-add-on-text '>{props.LoadingDetails ? "--" : `$ ${(props.ChargebeeInvoice.TaxAmount || Number(((0) / 100)).toFixed(2))}`}</div>
                            </div>
                            <div className="d-flex pt-1">
                                <div className='h5-regular color-secondary-accent ml-auto my-auto'>Total:</div>
                                <div className='h3-semibold color-add-on-text ml-auto '>{props.LoadingDetails ? "--" : `$ ${(props.ChargebeeInvoice.DueAmount || 0)}`}</div>

                            </div>
                        </div>
                        <div className={"mx-auto p-2"}>
                            <ButtonComponent ButtonLabel={buttonLabels.PAY_NOW} Variant={'primary-btn'} OnClick={() => { (props.PaymentLink) && window.open(props.PaymentLink, "_blank") }} ClassName="w-fill justify-center  b-none" />
                        </div>
                    </Grid>
                </Grid>}
        </Grid>

        <Dialog
            maxWidth="sm"
            fullWidth={true}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
            open={showEmail}
            onClose={handleSendEmail}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            classes={{ paper: "w-66 br-2 dialogue-shadow" }}
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header">
                <div className='d-flex'>
                    <span className={"h2-regular color-text-field-font"}>{ViewTextLabels.SEND_EMAIL}</span>
                    <Tooltip title='Close' placement='bottom'>
                        <CancelIcon className={"c-pointer ml-auto"} onClick={handleSendEmail} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <form onSubmit={(e) => sendEmail(e)}>
                <DialogContent className="o-x-hidden">
                    <Grid container direction="row" spacing={2}>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <FormTextField Label={"Full Name"} Name={"Name"} PlaceHolder={"Full Name"} Value={formData.Name} OnChange={(e) => {
                                setFormData({ ...formData, Name: e.target.value })
                            }} />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                            <FormTextField Label={"Email ID"} Name={"Email"} PlaceHolder={"Email ID"} Value={formData.Email} OnChange={(e) => {
                                setFormData({ ...formData, Email: e.target.value })
                            }} />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className={"d-flex float-right"}>
                    <Grid item xs={6} sm={12} md={12} lg={12} xl={12} className={"mr-2 my-2"}>
                        <ButtonComponent ButtonLabel={ViewTextLabels.SEND_EMAIL} Variant={"primary-btn-small"} Type={"submit"} Loading={showLoader} />
                    </Grid>
                </DialogActions>
            </form>
        </Dialog>
    </>

}

export default PaymentHostpageDetails;